import {
    IMasterListSearchByOptions,
    MasterListStatus,
} from "intake_shared/src/types";

export interface ClientMasterListNavigationState {
    clientMasterList?: {
        filterByStatus: MasterListStatus;
        searchByOptions: Omit<IMasterListSearchByOptions, "date_of_birth"> & {
            date_of_birth: string | null;
        };
        hasSearched: boolean;
    };
}

export function getClientMasterListNavigationState(
    state: unknown
): ClientMasterListNavigationState {
    return (state || {}) as ClientMasterListNavigationState;
}

export function getRestoredDate(value?: string | null) {
    if (!value) {
        return null;
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function serializeClientMasterListSearchOptions(
    searchByOptions: IMasterListSearchByOptions
) {
    return {
        ...searchByOptions,
        date_of_birth: searchByOptions.date_of_birth?.toISOString() ?? null,
    };
}
